import React from 'react';
import './SectionHeader.scss';

interface SectionHeaderProps {
  title: string;
  description?: string | React.ReactNode;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({ title, description }) => (
  <div className="section-header">
    <h2 className="section-title">{title}</h2>
    {description && (
      <div className="section-description">
        {description}
      </div>
    )}
  </div>
);

export default SectionHeader;
